/*
 * Copyright (c) 2020. Minerva Networks.
 * All rights reserved.
 */

import reduce from 'lodash.reduce';

export default class {
  constructor(duration) {
    this.duration = duration;
    this.completion = new Array(parseInt(duration, 10)).fill(0);
    this.previousTimeUpdate = 0;
    this.previousTime = 0;
    this.playedms = 0;
    this.seeking = false;
    this.e25 = false;
    this.e50 = false;
    this.e75 = false;
    this.stalled = false;
    this.stalledTime = false;
    this.performance = {
      playbackMap: false,
      interruptions: [],
      videoId: false,
      videoTitle: false,
    };
  }

  setPlayed(time) {
    const index = parseInt(time, 10);
    this.completion[index] = 1;
  }

  setPreviousTimeUpdate(time) {
    this.previousTimeUpdate = parseInt(time * 1000, 10);
  }

  setPreviousTime(time) {
    if (!this.seeking) {
      this.previousTime = parseInt(time * 1000, 10);
    }
  }

  getDiff(time) {
    const ms = parseInt(time * 1000, 10);
    return ms - this.previousTimeUpdate;
  }

  getSeekDiff(time) {
    const ms = parseInt(time * 1000, 10);
    return ms - this.previousTime;
  }

  getViewed() {
    const completed = reduce(this.completion, (sum, n) => sum + n, 0);
    if (completed === 0) {
      return 0;
    }
    return parseInt(((completed / this.completion.length) * 100), 10);
  }
}
